module.exports = __webpack_public_path__ + "static/d038a24dabb4b0defd4b29f1f7c44b10.svg";